export const DestinationAdminTableColumns = [
  { id: "name", label: "Name", minWidth: 170 },
  { id: "location", label: "Location", minWidth: 100 },
  {
    id: "type",
    label: "Type",
    minWidth: 170,
  },
  {
    id: "difficulty",
    label: "Difficulty",
    minWidth: 170,
  },
  {
    id: "maxElevation",
    label: "Max Elevention",
    minWidth: 170,
  },
  {
    id: "images",
    label: "Uploaded Images",
    minWidth: 170,
  },
  {
    id: "actions",
    label: "Actions",
  },
];


export const AdventureAdminTableColumns = [
  { id: "name", label: "Name", minWidth: 170 },
  { id: "location", label: "Location", minWidth: 100 },
  {
    id: "type",
    label: "Type",
    minWidth: 170,
  },
  {
    id: "difficulty",
    label: "Difficulty",
    minWidth: 170,
  },
  {
    id: "elevation",
    label: "Elevention",
    minWidth: 170,
  },
  {
    id: "startDate",
    label: "Start Date",
    minWidth: 170,
  },
  {
    id: "minAmount",
    label: "Min Amount",
    minWidth: 170,
  },
  {
    id: "actions",
    label: "Actions",
  },
];


export const ProgrammeAdminTableColumns = [
  { id: "name", label: "Name", minWidth: 170 },
  // { id: "description", label: "Description", minWidth: 100 },
  {
    id: "duration",
    label: "Duration",
    minWidth: 170,
  },
  {
    id: "startDate",
    label: "Start Date",
    minWidth: 170,
  },
  {
    id: "endDate",
    label: "End Date",
    minWidth: 170,
  },
  {
    id: "actions",
    label: "Actions",
  },
];